import { useState, useEffect } from "react";
import Shell from "@/components/Shell";
import { WORKSPACE_TABS } from "@/components/StudentWorkspace";

export default function WorkspaceShell({ mainNav, subtitle, children, studentId, studentName, track, readOnly }) {
  const [mainActive, setMainActive] = useState(mainNav[0]?.id);
  const [tab, setTab] = useState("overview");

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.tab) setTab(e.detail.tab);
    };
    window.addEventListener("ta-navigate", handler);
    return () => window.removeEventListener("ta-navigate", handler);
  }, []);

  return (
    <Shell
      subtitle={subtitle}
      nav={mainNav}
      active={mainActive}
      setActive={setMainActive}
      secondNav={WORKSPACE_TABS}
      secondActive={tab}
      setSecondActive={setTab}
    >
      {children(tab, mainActive)}
    </Shell>
  );
}
